import { render, staticRenderFns } from "./TaggingList.vue?vue&type=template&id=17dd7218"
import script from "./TaggingList.vue?vue&type=script&lang=js"
export * from "./TaggingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports